(function (global, factory) {
    if (typeof define === "function" && define.amd) {
        define(['exports', 'react', 'prop-types', 'react-required-if', 'react-cursor-position', 'react-hover-observer', './LensTop', './LensLeft', './LensRight', './LensBottom', './EnlargedImage', './ImageShape'], factory);
    } else if (typeof exports !== "undefined") {
        factory(exports, require('react'), require('prop-types'), require('react-required-if'), require('react-cursor-position'), require('react-hover-observer'), require('./LensTop'), require('./LensLeft'), require('./LensRight'), require('./LensBottom'), require('./EnlargedImage'), require('./ImageShape'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.react, global.propTypes, global.reactRequiredIf, global.reactCursorPosition, global.reactHoverObserver, global.LensTop, global.LensLeft, global.LensRight, global.LensBottom, global.EnlargedImage, global.ImageShape);
        global.ReactImageMagnify = mod.exports;
    }
})(this, function (exports, _react, _propTypes, _reactRequiredIf, _reactCursorPosition, _reactHoverObserver, _LensTop, _LensLeft, _LensRight, _LensBottom, _EnlargedImage, _ImageShape) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _react2 = _interopRequireDefault(_react);

    var _propTypes2 = _interopRequireDefault(_propTypes);

    var _reactRequiredIf2 = _interopRequireDefault(_reactRequiredIf);

    var _reactCursorPosition2 = _interopRequireDefault(_reactCursorPosition);

    var _reactHoverObserver2 = _interopRequireDefault(_reactHoverObserver);

    var _LensTop2 = _interopRequireDefault(_LensTop);

    var _LensLeft2 = _interopRequireDefault(_LensLeft);

    var _LensRight2 = _interopRequireDefault(_LensRight);

    var _LensBottom2 = _interopRequireDefault(_LensBottom);

    var _EnlargedImage2 = _interopRequireDefault(_EnlargedImage);

    var _ImageShape2 = _interopRequireDefault(_ImageShape);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    function _possibleConstructorReturn(self, call) {
        if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var ReactImageMagnify = function (_React$Component) {
        _inherits(ReactImageMagnify, _React$Component);

        function ReactImageMagnify(props) {
            _classCallCheck(this, ReactImageMagnify);

            var _this = _possibleConstructorReturn(this, (ReactImageMagnify.__proto__ || Object.getPrototypeOf(ReactImageMagnify)).call(this, props));

            _this.state = {
                smallImageWidth: 0,
                smallImageHeight: 0
            };

            _this.onSmallImageLoad = _this.onSmallImageLoad.bind(_this);
            _this.setSmallImageDimensionState = _this.setSmallImageDimensionState.bind(_this);
            return _this;
        }

        _createClass(ReactImageMagnify, [{
            key: 'onSmallImageLoad',
            value: function onSmallImageLoad() {
                if (!this.props.smallImage.isFluidWidth) {
                    return;
                }

                this.setSmallImageDimensionState();
            }
        }, {
            key: 'setSmallImageDimensionState',
            value: function setSmallImageDimensionState() {
                var _smallImageEl = this.smallImageEl,
                    smallImageWidth = _smallImageEl.offsetWidth,
                    smallImageHeight = _smallImageEl.offsetHeight;


                this.setState({
                    smallImageWidth: smallImageWidth,
                    smallImageHeight: smallImageHeight
                });
            }
        }, {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (this.props.smallImage.isFluidWidth) {
                    this.setSmallImageDimensionState();
                    window.addEventListener('resize', this.setSmallImageDimensionState);
                }
            }
        }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (this.props.smallImage.isFluidWidth) {
                    window.removeEventListener('resize', this.setSmallImageDimensionState);
                }
            }
        }, {
            key: 'render',
            value: function render() {
                var _this2 = this;

                var _props = this.props,
                    className = _props.className,
                    enlargedImageContainerClassName = _props.enlargedImageContainerClassName,
                    enlargedImageContainerStyle = _props.enlargedImageContainerStyle,
                    enlargedImageClassName = _props.enlargedImageClassName,
                    enlargedImageStyle = _props.enlargedImageStyle,
                    fadeDurationInMs = _props.fadeDurationInMs,
                    hoverDelayInMs = _props.hoverDelayInMs,
                    hoverOffDelayInMs = _props.hoverOffDelayInMs,
                    isSmallImageFluidWidth = _props.smallImage.isFluidWidth,
                    imageClassName = _props.imageClassName,
                    imageStyle = _props.imageStyle,
                    largeImage = _props.largeImage,
                    lensStyle = _props.lensStyle,
                    style = _props.style,
                    enlargedImagePosition = _props.enlargedImagePosition;


                var fluidWidthSmallImage = Object.assign({}, this.props.smallImage, {
                    width: this.state.smallImageWidth,
                    height: this.state.smallImageHeight
                });
                var fixedWidthSmallImage = this.props.smallImage;
                var smallImage = isSmallImageFluidWidth ? fluidWidthSmallImage : fixedWidthSmallImage;

                var cursorOffset = {
                    x: Math.round(smallImage.width / largeImage.width * smallImage.width / 2),
                    y: Math.round(smallImage.height / largeImage.height * smallImage.height / 2)
                };

                var defaultLensStyle = {
                    backgroundColor: 'rgba(0,0,0,.4)'
                };
                if (enlargedImagePosition === 'over') {
                    defaultLensStyle = {};
                }
                var compositLensStyle = Object.assign({}, defaultLensStyle, lensStyle);

                var fluidWidthContainerStyle = {
                    width: 'auto',
                    height: 'auto',
                    fontSize: '0px',
                    position: 'relative'
                };
                var fixedWidthContainerStyle = {
                    width: smallImage.width + 'px',
                    height: smallImage.height + 'px',
                    position: 'relative'
                };
                var priorityContainerStyle = isSmallImageFluidWidth ? fluidWidthContainerStyle : fixedWidthContainerStyle;
                var compositContainerStyle = Object.assign({
                    cursor: 'crosshair'
                }, style, priorityContainerStyle);

                var fluidWidthSmallImageStyle = {
                    width: '100%',
                    height: 'auto',
                    display: 'block'
                };
                var fixedWidthSmallImageStyle = {
                    width: smallImage.width + 'px',
                    height: smallImage.height + 'px'
                };
                var prioritySmallImageStyle = isSmallImageFluidWidth ? fluidWidthSmallImageStyle : fixedWidthSmallImageStyle;
                var compositSmallImageStyle = Object.assign({}, imageStyle, prioritySmallImageStyle);

                return _react2.default.createElement(
                    _reactCursorPosition2.default,
                    {
                        className: className,
                        style: compositContainerStyle
                    },
                    _react2.default.createElement(
                        _reactHoverObserver2.default,
                        {
                            hoverDelayInMs: hoverDelayInMs,
                            hoverOffDelayInMs: hoverOffDelayInMs,
                            onMouseEnter: function onMouseEnter(_ref) {
                                var setIsHovering = _ref.setIsHovering;
                                return setIsHovering();
                            },
                            onMouseLeave: function onMouseLeave(_ref2) {
                                var unsetIsHovering = _ref2.unsetIsHovering;
                                return unsetIsHovering();
                            },
                            onMouseOver: function onMouseOver(_ref3) {
                                var e = _ref3.e,
                                    unsetIsHovering = _ref3.unsetIsHovering;

                                if (e.target.getAttribute('data-hover') === 'false') {
                                    unsetIsHovering();
                                }
                            }
                        },
                        _react2.default.createElement('img', {
                            src: smallImage.src,
                            srcSet: smallImage.srcSet,
                            sizes: smallImage.sizes,
                            alt: smallImage.alt,
                            className: imageClassName,
                            style: compositSmallImageStyle,
                            ref: function ref(el) {
                                return _this2.smallImageEl = el;
                            },
                            onLoad: this.onSmallImageLoad
                        }),
                        _react2.default.createElement(_LensTop2.default, {
                            cursorOffset: cursorOffset,
                            fadeDurationInMs: fadeDurationInMs,
                            smallImage: smallImage,
                            style: compositLensStyle
                        }),
                        _react2.default.createElement(_LensLeft2.default, {
                            cursorOffset: cursorOffset,
                            fadeDurationInMs: fadeDurationInMs,
                            smallImage: smallImage,
                            style: compositLensStyle
                        }),
                        _react2.default.createElement(_LensRight2.default, {
                            cursorOffset: cursorOffset,
                            fadeDurationInMs: fadeDurationInMs,
                            smallImage: smallImage,
                            style: compositLensStyle
                        }),
                        _react2.default.createElement(_LensBottom2.default, {
                            cursorOffset: cursorOffset,
                            fadeDurationInMs: fadeDurationInMs,
                            smallImage: smallImage,
                            style: compositLensStyle
                        }),
                        _react2.default.createElement(_EnlargedImage2.default, {
                            containerClassName: enlargedImageContainerClassName,
                            containerStyle: enlargedImageContainerStyle,
                            cursorOffset: cursorOffset,
                            fadeDurationInMs: fadeDurationInMs,
                            imageClassName: enlargedImageClassName,
                            imageStyle: enlargedImageStyle,
                            largeImage: largeImage,
                            smallImage: smallImage,
                            imagePosition: enlargedImagePosition
                        })
                    )
                );
            }
        }]);

        return ReactImageMagnify;
    }(_react2.default.Component);

    ReactImageMagnify.propTypes = {
        className: _propTypes2.default.string,
        enlargedImageContainerClassName: _propTypes2.default.string,
        enlargedImageContainerStyle: _propTypes2.default.object,
        enlargedImageClassName: _propTypes2.default.string,
        enlargedImageStyle: _propTypes2.default.object,
        fadeDurationInMs: _propTypes2.default.number,
        hoverDelayInMs: _propTypes2.default.number,
        hoverOffDelayInMs: _propTypes2.default.number,
        imageClassName: _propTypes2.default.string,
        imageStyle: _propTypes2.default.object,
        largeImage: _ImageShape2.default,
        lensStyle: _propTypes2.default.object,
        smallImage: _propTypes2.default.shape({
            alt: _propTypes2.default.string,
            isFluidWidth: _propTypes2.default.bool,
            src: _propTypes2.default.string.isRequired,
            srcSet: _propTypes2.default.string,
            sizes: _propTypes2.default.string,
            width: (0, _reactRequiredIf2.default)(_propTypes2.default.number, function (props) {
                return !props.isFluidWidth;
            }),
            height: (0, _reactRequiredIf2.default)(_propTypes2.default.number, function (props) {
                return !props.isFluidWidth;
            })
        }),
        style: _propTypes2.default.object,
        enlargedImagePosition: _propTypes2.default.oneOf(['beside', 'over'])
    };
    ReactImageMagnify.defaultProps = {
        enlargedImagePosition: 'beside',
        fadeDurationInMs: 300,
        hoverDelayInMs: 250,
        hoverOffDelayInMs: 150
    };
    exports.default = ReactImageMagnify;
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-image-magnify/dist/ReactImageMagnify.js
 ** module id = 1103
 ** module chunks = 0
 **/